<template>
    <div>
        <vs-alert warn v-if="rowData.registros_academicos_vinculados != 0">
            <template #title>
                El grupo se encuentra bloqueado debido a que existen alumnos vinculados.
            </template>
        </vs-alert>
        <vs-row style="justify-content:flex-end">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="6">
                <vs-input v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </vs-col>
        </vs-row>
        <vs-table v-model="selectedRow" class="unset-min-width left-footer-unset-radius left-header-unset-radius">
            <template #thead>
                <vs-tr>
                    <!-- <vs-th style="width: 25px !important;">
                        <vs-checkbox
                            :indeterminate="selectedRow.length == tablaData.length" v-model="allCheck"
                            @change="selectedRow = $vs.checkAll(selectedRow, tablaData)"
                        />
                    </vs-th> -->
                    <vs-th class="cienCincuenta">
                        Asignatura
                    </vs-th>
                    <vs-th class="cienCincuenta">
                        Profesor
                    </vs-th>
                </vs-tr>
            </template>
            <template #tbody>
                <vs-tr :key="i" v-for="(tr, i) in $vs.getSearch(tablaData, search)" :data="tr"  style="border-bottom: 1px solid #ccc">
                    <!-- <vs-td checkbox>
                        <vs-checkbox :val="tr" v-model="selectedRow" />
                    </vs-td> -->
                    <vs-td>
                        <md-content class="cienCincuenta">
                            {{ tr.alias }}
                        </md-content>
                    </vs-td>
                    <vs-td>
                        <md-content class="cienCincuenta d-block" style="width: 100%;">
                            <div v-for="(infor, i) in tr.academico_sesiones" :key="i" class="center con-checkbox horariosCheck">
                                <vs-checkbox :class="rowData.registros_academicos_vinculados == 0 ? '' : 'vs-checkbox--disabled'" :val="infor" v-model="profesor" @change="getMultiples(infor)">
                                    <p class="mb-0" style="font-size: 12px;"><strong>{{infor.docente_en_aula.nombres }} {{infor.docente_en_aula.apellido_paterno }} {{infor.docente_en_aula.apellido_materno }}</strong></p>
                                    <p class="mb-0">Aula: {{infor.aula.nombre}} </p>
                                    <p class="mb-0">{{infor.diaTitle}}</p>
                                    <p v-if="infor.hora_inicio && infor.hora_fin" class="mb-0">Horario: <strong>{{infor.hora_inicio}}</strong> a <strong>{{infor.hora_fin}}</strong></p>
                                </vs-checkbox>
                            </div>
                        </md-content>
                    </vs-td>
                    
                </vs-tr>
            </template>
            <template #notFound>
                No hay registros
            </template>
            <template #footer>
                <vs-pagination v-model="page" :length="pages" />
            </template>
        </vs-table>
    </div>
</template>

<script>
import { combineAll } from 'rxjs/operators'
import crns from '../../../../api/requests/crns.js'

export default {
    props:[
        'value',
        'institucion',
        'cicloEscolar',
        'nivelAcademico',
        'programa',
        'crns',
        'rowData',
        'grado'
    ],   
    data () {
        return {
            search: '',
            allCheck: false,
            selectedRow: [],
            tablaData: [],
            page: 1, 
            max: 5,
            pages: 0, 
            profesor: [],
            proff: [],
        }
    },
    methods: {
        getMarcados(){
            let sesion = this.rowData.sesiones
            const vue = this
            if(sesion){
                sesion.forEach(a =>{
                    this.tablaData.forEach(i=>{
                        i.academico_sesiones.forEach(j =>{
                            if(j.docente_en_aula_id === a.docente_en_aula_id && j.aula_id === a.aula_id && j.crn_id === a.crn_id && a.id === j.id){
                                // let isIn = false
                                // vue.profesor.forEach(element => {
                                //     if(element.id === a.id){
                                //         isIn = true
                                //     }
                                // })
                                // if(!isIn){
                                    vue.profesor.push(j)
                                // }
                            }
                        })
                    })
                })
            }
        },
        getMultiples(infor){
            var checked = false
            this.profesor.forEach(i =>{
                if (i === infor){
                    checked = true
                }
            })
            const vue = this
            const proff = []
            const select = []
            const proff_id = vue.profesor.map(el => el.id)
            vue.tablaData.forEach(i => {
                if(i.academico_sesiones[0]){
                    i.academico_sesiones.forEach(j => {
                        if(infor !== j){
                            if(infor.docente_en_aula_id === j.docente_en_aula_id && infor.aula_id === j.aula_id && infor.crn_id === j.crn_id){
                                if(checked && !proff_id.includes(j.id)){
                                    vue.profesor.push(j)
                                }
                                // else {
                                    // var index = 0
                                    // let a = 0
                                    // vue.profesor.forEach(z =>{
                                    //     if (z === j){
                                    //         index = a
                                    //     }
                                    //     a++
                                    // })
                                    // vue.profesor.splice(indice, 1)
                                // }
                            }
                        }
                    })
                }
            })
            vue.proff = select
        },
        async tablaCodigos () {
            if(this.grado){
                try {
                    let params = {
                        page: this.page || 1,
                        size: this.max || 20
                    }
                    if (this.cicloEscolar) {
                        params.ciclo_escolar_id = this.cicloEscolar 
                    }
                    if (this.nivelAcademico) {
                        params.nivel_academico_id = this.nivelAcademico 
                    }
                    if (this.programa) {
                        params.programa_id = this.programa 
                    }
                        params.grado_id = this.grado 
                    const { data: response = null } = await crns.listadoCrn (this.institucion, params) || {}
                    const { data: dataTable = [], per_page = 20, total = 0 } = response || {}
                    this.pages = Math.ceil(total/per_page) || 0
                    this.tablaData = dataTable
                    if (Array.isArray(this.tablaData) && Array.isArray(this.crns) 
                        && this.tablaData.length && this.crns.length
                    ){
                        const crnIds = this.crns.map(e=>e.id)
                        this.selectedRow = this.tablaData.filter(e => crnIds.includes(e.id))
                    }
                } catch (error) {
                    this.tablaData = []
                    this.pages = 0
                }
            }
        }
    },
    watch:{
        page () {
            this.tablaCodigos()
        },
        profesor (val) {
            if (val){
                this.$emit('input', val);
            }
        },
        tablaData(){
            this.getMarcados()
        },
        grado(){
            this.tablaCodigos()
        }
    }
}
</script>

<style>
    .cienCincuenta {
        width: 150px;
        background: none;
    }

    div.horariosCheck > div.vs-checkbox-content > label{
        display: block;
    }
</style>

<style scoped>
.vs-checkbox-label{
    display: block !important;
}
</style>